/** Chart colours, duplicated from the CSS tokens so this folder stays deletable. */
export const CHART_COLORS = {
  success: '#6f9a55',
  accent: '#d4a017',
  warning: '#d4a017',
  danger: '#c45c4a',
  grid: '#32383f',
  axis: '#9aa3ad',
  surface: '#1c2024',
  border: '#454d56',
  text: '#ecece8',
} as const;

export const TOOLTIP_STYLE = {
  background: CHART_COLORS.surface,
  border: `1px solid ${CHART_COLORS.border}`,
  borderRadius: 6,
  color: CHART_COLORS.text,
  fontSize: 12,
} as const;

export const AXIS_TICK = { fill: CHART_COLORS.axis, fontSize: 12 } as const;
